export default __webpack_public_path__ + "static/media/pic9.f860eb66.jpg";